"use client";
import React, { createContext, useContext, useMemo, useState } from "react";

interface UnseenNotificationCountContextType {
  unseenCount: number;
  setUnseenCount: (count: number) => void;
}

const UnseenNotificationCountContext = createContext<UnseenNotificationCountContextType>({
  unseenCount: 0,
  setUnseenCount: () => {},
});

export function UnseenNotificationCountProvider({ children }: { children: React.ReactNode }) {
  const [unseenCount, setUnseenCount] = useState(0);

  const value = useMemo(() => ({ unseenCount, setUnseenCount }), [unseenCount]);

  return (
    <UnseenNotificationCountContext.Provider value={value}>
      {children}
    </UnseenNotificationCountContext.Provider>
  );
}

export function useUnseenNotificationCount() {
  return useContext(UnseenNotificationCountContext);
}
